<script>
import resources from './resources'

export default {
  name: 'gadget-agenda-estatistics-professional',
  mixins: [resources]
}
</script>

<template lang="pug">
  section.gadget-estatisticas-agendas.white-bg.wrapper.full-width.gadget
    .gadget-title
      | Estatísticas
    .actions
      span.icon 
      ul
        li.exclude Remover
        li.half-width Lado a Lado
        li.full-width Tela Inteira
    .item
      .icon
        span.icon 
      .total
        | {{ agendas }}
      .title Agendas Ativas
    .item
      .icon
        span.icon 
      .total
        | {{ scheduled }}
      .title Consultas Agendadas
    .item
      .icon
        span.icon 
      .total
        | {{ attended }}
      .title Consultas Realizadas
    .item
      .icon
        span.icon 
      .total
        | {{ canceled }}
      .title Consultas Canceladas
    .item
      .icon
        span.icon 
      .total
        | {{ absent }}
      .title Absenteísmo
</template>



// WEBPACK FOOTER //
// src/app/employee/dashboard/gadget/components/statistics/statistics.vue